interface State {
  id: number;
  abbreviation: string;
  name: string;
}

export class BrStatesUtil {
  private static instance: BrStatesUtil;
  private states: State[] = states;
  private statesMapperByAbbreviation = new Map<string, State>();
  private statesMapperByName = new Map<string, State>();
  private allAbbreviations: string[] = [];
  private allNames: string[] = [];

  private constructor() {
    this.states.forEach(state => {
      this.statesMapperByAbbreviation.set(state.abbreviation, state);
      this.statesMapperByName.set(state.name, state);
      this.allNames.push(state.name);
      this.allAbbreviations.push(state.abbreviation);
    });
  }

  public static getInstance(): BrStatesUtil {
    if (!BrStatesUtil.instance) {
      BrStatesUtil.instance = new BrStatesUtil();
    }
    return BrStatesUtil.instance;
  }

  getAllAbbreviations() {
    return this.allAbbreviations;
  }

  getAllNames() {
    return this.allNames;
  }

  getAbbreviationByName(name: string) {
    return this.statesMapperByName.get(name)?.abbreviation;
  }

  getNameByAbbreviation(abbreviation: string) {
    return this.statesMapperByAbbreviation.get(abbreviation)?.name;
  }

  isValidAbbreviation(abbreviation: string) {
    return !!this.statesMapperByAbbreviation.get(abbreviation);
  }

  getStates() {
    return this.states;
  }
}

const states: State[] = [
  { id: 1, abbreviation: 'AC', name: 'Acre' },
  { id: 2, abbreviation: 'AL', name: 'Alagoas' },
  { id: 3, abbreviation: 'AP', name: 'Amapá' },
  { id: 4, abbreviation: 'AM', name: 'Amazonas' },
  { id: 5, abbreviation: 'BA', name: 'Bahia' },
  { id: 6, abbreviation: 'CE', name: 'Ceará' },
  { id: 7, abbreviation: 'DF', name: 'Distrito Federal' },
  { id: 8, abbreviation: 'ES', name: 'Espírito Santo' },
  { id: 9, abbreviation: 'GO', name: 'Goiás' },
  { id: 10, abbreviation: 'MA', name: 'Maranhão' },
  { id: 11, abbreviation: 'MT', name: 'Mato Grosso' },
  { id: 12, abbreviation: 'MS', name: 'Mato Grosso do Sul' },
  { id: 13, abbreviation: 'MG', name: 'Minas Gerais' },
  { id: 14, abbreviation: 'PA', name: 'Pará' },
  { id: 15, abbreviation: 'PB', name: 'Paraíba' },
  { id: 16, abbreviation: 'PR', name: 'Paraná' },
  { id: 17, abbreviation: 'PE', name: 'Pernambuco' },
  { id: 18, abbreviation: 'PI', name: 'Piauí' },
  { id: 19, abbreviation: 'RJ', name: 'Rio de Janeiro' },
  { id: 20, abbreviation: 'RN', name: 'Rio Grande do Norte' },
  { id: 21, abbreviation: 'RS', name: 'Rio Grande do Sul' },
  { id: 22, abbreviation: 'RO', name: 'Rondônia' },
  { id: 23, abbreviation: 'RR', name: 'Roraima' },
  { id: 24, abbreviation: 'SC', name: 'Santa Catarina' },
  { id: 25, abbreviation: 'SP', name: 'São Paulo' },
  { id: 26, abbreviation: 'SE', name: 'Sergipe' },
  { id: 27, abbreviation: 'TO', name: 'Tocantins' },
];
